import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import type { scheduledTransactionsTypes } from 'app-components/flux/scheduled-transactions';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

export const DIALOG_TYPE = 'SCHEDULED_TRANSACTION_ADD_DIALOG';

export const showAddScheduledTransactionDialog = createAction(
  rootUiActions.createDialog.toString(),
  (txnFilter: { dialogType: scheduledTransactionsTypes.STType } | undefined) =>
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE,
      id: DIALOG_TYPE,
      props: txnFilter ? ImmutableMap(txnFilter) : undefined,
    }),
);
